import(/* webpackMode: "eager" */ "/app/src/modules/bonusShop/BonusShop.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/bonusShop/hooks/useBonusShopExchange.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/bonusShop/hooks/useBonusShopProductExchange.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/bonusShop/hooks/useBonusShopProducts.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/bonusShop/hooks/useCanExchangeBonuses.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/localization/hooks/useLanguageChange.ts");
